import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { ClientAuthBrandPanel } from '@/components/layouts/components/ClientAuthBrandPanel';
import { VerifyEmailScreen } from '@/features/auth/components/VerifyEmailScreen';

export const Route = createFileRoute('/verify-email/')({
  component: Page,
  validateSearch: (s: Record<string, unknown>) => ({
    token: typeof s.token === 'string' ? s.token : undefined,
    email: typeof s.email === 'string' ? s.email : undefined,
  }),
});

function Page() {
  return (
    <AuthLayout formSide="right" brandPanel={<ClientAuthBrandPanel />}>
      <VerifyEmailScreen />
    </AuthLayout>
  );
}
